export class PreChatConstants {
    // UP-8371 We stopped supporting IE in 5.0, however coming up on 5.0 release the current implementation now calls EmailValidator on pre-chat init.
    //         The look behind in regular expressions is not supported by IE (and perhaps some early versions of FF), so use a string instead.

    // If local part of the email is unquoted it allows following:
    // - uppercase and lowercase letters A to Z and a to z
    // - digits 0 to 9
    // - characters !#$%&'*+-/=?^_`{|}~
    // - dot ., provided that it is not the first or last character and it does not appear consecutively
    public static readonly EMAIL_REGEXP = "^[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(\\.?[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9]([a-z0-9-]*[a-z0-9])?$";

    // In exceptional case local part of the email can be enclosed in quotes. In such case in addition to conditions described above it allows:
    // - whitespaces
    // - dot . can be a first or last character and appear consecutively
    // - characters (),:;<>@[\]
    public static readonly QUOTED_EMAIL_REGEXP = "^\"[a-z0-9!#$%&'*+\\/=?^_`{|}~\\- \\.(),:;<>\\\\@\\[\\]]+\"@([a-z0-9]([a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9]([a-z0-9-]*[a-z0-9])?$";
}
